
import ConvertCard from "../../../assets/outline/ConvertCard.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ConvertCardIcon({ className, dataTestid = "ConvertCardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ConvertCard data-testid={dataTestid} className={classes} {...rest} />
  );
}
